import React from 'react';
import {useLocation} from "react-router-dom";
import {useDispatch} from "react-redux";
import {ButtonMain, MinLoader, SwitchMain} from "components";
import {RoutersInfo} from "root";
import {ExportCsv} from "fragments";
import {IdleVehicles} from "./idleVehicles";
import {ImportCsv} from "./importCSV";
import {dispatchBoardCsv} from "../constants";
import {Svg} from "assets";
import {FindLoad, newDateWithoutUtc, useModal} from "utils";
import {legsActions} from "store";

const REFRESH_ALL_DATA = 'REFRESH_ALL_DATA'

export const MainHeader = ({pathname, control, addTrip, serviceDate, mapView}) => {
    const {openModal} = useModal();
    const dispatch = useDispatch()
    const location = useLocation();
    const loadingRefresh = FindLoad(REFRESH_ALL_DATA);
    const info = location?.state;

    const currentPage = RoutersInfo()?.find((rout) =>
        pathname?.startsWith(rout?.path),
    );

    const handleIdleVehicle = () => {
        openModal(
            <IdleVehicles serviceDate={serviceDate}/>, {
                noShowCloseBtn: true,
                padding: "noPaddings",
                maxWidth: 990,
            })
    }

    const handleExportCSV = () => {
        openModal(
            <ExportCsv params={dispatchBoardCsv}/>,
            {
                noShowCloseBtn: true,
                padding: "noPaddings",
                maxWidth: 610,
            })
    }

    const handleImportCSV = () => {
        openModal(
            <ImportCsv/>,
            {
                noShowCloseBtn: true,
                padding: "noPaddings",
                maxWidth: 508,
            })
    }

    const renderParams = () => {
        return {
            ...info,
            serviceDate: newDateWithoutUtc(serviceDate),
        };
    }

    const handleRefresh = async () => {
        const params = renderParams();
        dispatch(legsActions.refreshAllData(params, mapView))
    }

    return (
        <div className="main-info-fragment-header">
            <p className="main-info-fragment-header-title">{currentPage?.name}</p>

            <div className='main-info-fragment-header-right-side'>
                <SwitchMain
                    label='Map View'
                    name='mapView'
                    control={control}
                    labelPlacement='right'
                />

                <div className="line"/>

                <SwitchMain
                    label='Duplicates Only'
                    name='duplicate'
                    control={control}
                    labelPlacement='right'
                />

                <div className="line"/>

                <SwitchMain
                    label='Dialysis Only'
                    name='dialysisOnly'
                    control={control}
                    labelPlacement='right'
                />

                <div className="line"/>

                <button
                    className='main-info-fragment-header-btn'
                    type='button'
                    onClick={handleIdleVehicle}
                >
                    Idle Vehicles
                </button>

                <div className="line"/>

                <button
                    className='main-info-fragment-header-btn'
                    type='button'
                    onClick={handleRefresh}
                    style={{width: 105}}
                >
                    {loadingRefresh ?
                        <MinLoader margin={"0"} color={"#172B4D"}/>
                        :
                        <Svg.Refresh2Svg/>
                    }
                    Refresh
                </button>

                <button
                    className='main-info-fragment-header-btn'
                    type='button'
                    onClick={handleImportCSV}
                >
                    <Svg.ImportSvg/>
                    Import CSV
                </button>

                <button
                    className='main-info-fragment-header-btn'
                    type='button'
                    onClick={handleExportCSV}
                >
                    <Svg.ExportCSVSvg/>
                    Export CSV
                </button>

                {addTrip &&
                    <ButtonMain
                        text={'Add Trip'}
                        startIcon={<Svg.PlusSvg/>}
                        onClick={() => addTrip()}
                        small
                        buttonMainStyles={{
                            width: "fit-content",
                            padding: "6px 12px",
                        }}
                    />
                }
            </div>
        </div>
    );
};

